import { ScrollArea } from '@repo/shadcn';

import { IwForm } from '@/components/form';

import { AddPaymentFormSchema, INITIAL_VALUE } from './add-payment-form.schema';
import { AddPayment } from './add-payment.component';
import { CartActions } from './cart-actions.component';
import { CartItems } from './cart-items.component';
import { CartProvider, useCartContext } from './cart.context';
import { CustomerSelector } from './customer-selector.component';
import { OrderSummary } from './order-summary.component';
import { ProductSelector } from './product-selector.component';
import { SubmitOrder } from './submit-order.component';

const CartComponent = () => {
    const { handleConfirmOrderMultiPayment, activeCart, formRef } =
        useCartContext();

    const totalPrice = activeCart?.data?.info?.total_price ?? 0;

    return (
        <div className="grid grid-cols-[3fr_1fr] gap-4">
            <div className="space-y-2">
                {/*<OrderTypeSelector />*/}
                <ProductSelector />
                <CartActions />
                {/*<ScrollArea className={'h-[calc(100vh_-_260px)]'}>*/}
                <ScrollArea className={'h-[calc(100vh_-_300px)]'}>
                    <CartItems />
                </ScrollArea>
            </div>

            <IwForm
                schema={AddPaymentFormSchema}
                ref={formRef}
                logErrors
                initialValues={INITIAL_VALUE}
                onSubmit={handleConfirmOrderMultiPayment as any}
            >
                <ScrollArea className={'relative h-[calc(100vh_-_100px)]'}>
                    <div className="h-[calc(100vh_-_100px)] space-y-4 pb-[100px] ">
                        <OrderSummary />
                        <AddPayment totalPrice={totalPrice} />
                        <CustomerSelector />
                        <SubmitOrder />
                    </div>
                </ScrollArea>
            </IwForm>
        </div>
    );
};

CartComponent.displayName = 'CartComponent';

export const Cart = () => {
    return (
        <CartProvider>
            <CartComponent />
        </CartProvider>
    );
};

Cart.displayName = 'Cart';
